import { Stack } from 'react-bootstrap';
import { useTheme } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCloudUploadAlt,
  faPaperclip,
} from '@fortawesome/free-solid-svg-icons';
import useResponsive from 'shared/hooks/misc/useResponsive';
import Button from 'shared/components/common/Button';
import FileUpload from '../FileUpload';

export default function Attachments({ entity, entityType, onUploaded }) {
  const theme = useTheme();
  const { isMobile } = useResponsive();
  const { id: objectId } = entity || {};

  return (
    <div className="my-2 fs-8 fw-medium">
      <div className="ls-1 text-uppercase mb-2">Attachments</div>
      <FileUpload
        dropMessage={
          <Stack direction="horizontal" gap={{ md: 5, lg: 3, xl: 4 }} className="px-2 py-0">
            {!isMobile && (
              <>
                <Stack direction="vertical">
                  <FontAwesomeIcon
                    size="lg"
                    className="mb-1 mx-auto"
                    icon={faCloudUploadAlt}
                    color={theme.color.palette.grey[700]}
                    fixedWidth
                  />
                  <span className="text-secondary text-center">Drag to upload</span>
                </Stack>
                <span className="fs-7 text-secondary">or</span>
              </>
            )}
            {isMobile ? (
              <Button type="text" linkButton className="w-100">
                <FontAwesomeIcon
                  size="lg"
                  icon={faPaperclip}
                  color={theme.color.palette.text.link}
                  className="me-3"
                />
                <span>Browse</span>
              </Button>
            ) : (
              <Button type="outlined">Browse</Button>
            )}
          </Stack>
        }
        dataType={entityType}
        objectId={objectId || null}
        setNewAttachments={onUploaded}
      />
    </div>
  );
}
